import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content_wrapper tw-px-[25px] tw-pb-[25px]" }

import { ref } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import TableActionSwitchTab from "./tableActionSwitchTab.vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";
import { idTabActionTableRecommendation } from "@/utils/constants";
import overviewDetailActionTab from "./overviewDetailActionTab.vue";
import StepToSolveDetailActionTab from "./stepToSolveDetailActionTab.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'detailRowActionTable',
  props: {
  detailData: {
    type: Object as () => any,
    required: false,
    default: null,
  },
  idItemExpand: {
    type: [String, Number],
    required: false,
    default: null,
  },
  isActionTable: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {



const activeTab = ref("1");

// add tab component to feild component
const tabs: ISwitchTabs[] = [
  {
    title: getComponentUiText(
      "app-assess-recommendations-action-table-label-tab-overview-1",
    ),
    id: idTabActionTableRecommendation.overview,
    component: overviewDetailActionTab,
  },
  {
    title: getComponentUiText(
      "app-assess-recommendations-action-table-label-tab-action-plan-1",
    ),
    id: idTabActionTableRecommendation.stepsToSolve,
    component: StepToSolveDetailActionTab,
  },
  // {
  //   title: getComponentUiText(
  //     "app-assess-recommendations-action-table-label-tab-makeplan-1",
  //   ),
  //   id: idTabActionTableRecommendation.makePlan,
  //   component: MakePlanDetailTab,
  // },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TableActionSwitchTab, {
      tabs: tabs,
      "default-tab": 0,
      "onUpdate:tab": _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = $event))
    }),
    (_openBlock(), _createBlock(_resolveDynamicComponent(tabs.filter((item) => item.id === activeTab.value)[0].component), {
      class: "tw-h-[18px] tw-w-[18px]",
      data: __props.detailData,
      "id-item-expand": __props.idItemExpand,
      "is-action-table": __props.isActionTable
    }, null, 8, ["data", "id-item-expand", "is-action-table"]))
  ]))
}
}

})